function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.389 17.11l5.069 1.877 1.962 6.26c.125.4.62.548.948.282l2.825-2.285a.848.848 0 011.028-.028l5.097 3.67c.35.253.848.063.936-.358l3.733-17.814a.596.596 0 00-.8-.673L5.383 16a.591.591 0 00.006 1.11zm7.1 1.91l10.237-5.993c.184-.107.373.13.215.268l-8.448 7.464a1.639 1.639 0 00-.542.996l-.288 2.027c-.038.27-.438.297-.517.035l-1.106-3.696a.958.958 0 01.45-1.102z",
  fill: "#FFF",
  fillRule: "nonzero"
});

function SvgTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33
  }, props), _ref);
}

export default __webpack_public_path__ + "b57ed32703391d4afce88020180ca7d0.svg";
export { SvgTelegram as ReactComponent };